export enum OmsSetupPath {
  Expert = "expert",
  Self = "self",
}
